import React from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import Home from "./components/Home.js";
import Navbar from "./components/Navbar.js"; 
import Contact from "./components/Contact.js"; 
import Imprint from "./components/Imprint.js";
import Portfolio from "./components/Portfolio.js";
import Projects from "./components/Projects.js";
import Audio from "./components/Audio.js";
import Video from "./components/Video.js";
import Photography from "./components/Photography.js";
import ScrollToTop from "./components/ScrollToTop.js";

const App = () => {
  return (

    <Router>
      <ScrollToTop />
      <div className="app-container">
        <Navbar />
        <div className="content">
          {/* Routing */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/portfolio/audio" element={<Audio />} />
            <Route path="/portfolio/video" element={<Video />} />
            <Route path="/portfolio/photography" element={<Photography />} />

          </Routes>
        </div>  
      </div>    
      <footer>
        <Imprint />
      </footer>  
    </Router>


  );
};

export default App;
